import React from 'react';
import LiveChat from "../CustomerSupport/LiveChat";
import ContactForm from "../CustomerSupport/ContactForm";
import styles from "../CustomerSupport/styles.module.scss";
import CustomerSupportHero from "../CustomerSupport/CustomerSupportHero";
import useTranslation from "next-translate/useTranslation";

import Footer from "./ContactUsFooter";
import {COMMON_NAMESPACE, CONTACT_US_NAMESPACE} from "../../../utils/i18nNameSpaces";
import {GROUP_PHONE, HR_SOFTWARE, SOFTWARE_PHONE, SUPPORT_GROUP} from "../../../utils/constants";

const Index = () => {
  const {t} = useTranslation(CONTACT_US_NAMESPACE);
  const stackList = [
    t(`stack.careers`),
    t(`stack.partnership`),
    t(`${COMMON_NAMESPACE}:stack.other`)
  ]

  return (
    <div className={styles["main"]}>
      <CustomerSupportHero t={t}/>
      <LiveChat t={t} phone={SOFTWARE_PHONE.code}/>
      <ContactForm contactT={t} email={HR_SOFTWARE} phone={SOFTWARE_PHONE} stackList={stackList}/>
      <Footer/>
    </div>
  );
};

export default Index;